import { useMutation } from '@vue/apollo-composable';
import gql from 'graphql-tag';

const UPDATE_LOCATION_MUTATION = gql`
  mutation UpdateLocation($companyid: ID!, $lat: Float!, $lng: Float!) {
    updateLocation(COMPANYID: $companyid, lat: $lat, lng: $lng)
  }
`;

export default function useUpdateLocation() {
  const { mutate, loading, error } = useMutation(UPDATE_LOCATION_MUTATION);

  async function updateLocation(companyid, lat, lng) {
    try {
      const { data } = await mutate({ companyid, lat, lng });
      return data.updateLocation;
    } catch (error) {
      console.error('Error updating location:', error);
      throw new Error('Error updating location.');
    }
  }

  return {
    updateLocation,
    loading,
    error,
  };
}
